import React, { Component } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import { EBreceiptData } from "./sopDataTemplate";

interface AllProps {
  data: EBreceiptData;
  handleEBreceiptChange: any;
  isOnlyView?: boolean;
}
export class EBreceipt extends Component<AllProps> {
  state = {
    isOptionOpen: false,
    bgColor: "#ffff8d",
    responseData: {},
  };

  componentDidMount() {
    const { data } = this.props;
    this.setState({
      responseData: JSON.parse(JSON.stringify(data)),
    });
  }

  changeBgColor = () => {
    const { bgColor } = this.state;
    if (bgColor !== "lightgreen") {
      this.setState({ bgColor: "lightgreen" });
    }
  };
  handleChange = (name, val) => {
    const { data } = this.props;
    data[name] = val;
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleEBreceiptChange(data);
  };
  handleStateChange = (stateName, value) => {
    console.log("value", value);
    this.setState(
      {
        [stateName]: value,
      },
      () => {
        this.changeBgColor();
      }
    );
  };
  handleFileChange = (name, val) => {
    const { data } = this.props;
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleEBreceiptChange(data);
  };
  getOtherProps = (key) => {
    // const { data, isOnlyView } = this.props;
    // if (isOnlyView) return { [key]: true };
    return null;
  };

  handleChildInputChange = (key, name, value, index?) => {
    const { data } = this.props;
    if (index !== undefined) data[key][index][name] = value;
    else data[key][name] = value;
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleEBreceiptChange(data);
  };
  handleChildRadioChange = (key, name, val, index?) => {
    const { data } = this.props;
    if (index !== undefined) {
      data[key][index][name] = val;
    } else {
      data[key][name] = val;
    }
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleEBreceiptChange(data);
  };

  addChild = (type) => {
    const { data } = this.props;

    // Create a copy of data or initialize a new object
    const updatedData = data ? { ...data } : {};

    // Ensure the type property exists as an array
    if (!updatedData[type] || !Array.isArray(updatedData[type])) {
      updatedData[type] = [];
    }

    // Add new child object
    updatedData[type].push({
      dateVerified: false,
      propertOwnerVerify: false,
      ebAmountverify: false,
      receiptIssuedByVerify: false,
    });

    // Update parent component
    this.props.handleEBreceiptChange(updatedData);
  };

  removeChild = (type, index) => {
    const { data } = this.props;
    delete data[type][index];
    const updatedLegalHeirs = data[type].filter((item) => item !== null);
    data[type] = updatedLegalHeirs;
    this.props.handleEBreceiptChange(data);
  };

 getAddButton = (title: string, value: string, showRadioForSection?: boolean) => {
    const { data } = this.props;

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }}
        >
            <div style={{ display: "flex", alignItems: "center" }}>
                <h6 style={{ margin: 0 }}>
                    <b>{title}</b>
                </h6>

                {/* Show radio buttons only for the specified section */}
                {showRadioForSection === true && (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            marginLeft: "20px",
                        }}
                    >
                        <Form.Check
                            inline
                            label="Yes"
                            name={`isshow${value}Status`}
                            type="radio"
                            id={`isshow${value}Status-yes`}
                            checked={data[`isshow${value}Status`] === true}
                            onChange={() => {
                                const fieldName = `isshow${value}Status`;
                                data[fieldName] = true;
                                this.changeBgColor();
                                data.bgColor = "lightgreen";
                                this.props.handleEBreceiptChange(data);
                            }}
                            style={{ marginRight: "15px" }}
                        />
                        <Form.Check
                            inline
                            label="No"
                            name={`isshow${value}Status`}
                            type="radio"
                            id={`isshow${value}Status-no`}
                            checked={data[`isshow${value}Status`] !== true}
                            onChange={() => {
                                const fieldName = `isshow${value}Status`;
                                data[fieldName] = false;
                                this.changeBgColor();
                                data.bgColor = "lightgreen";
                                this.props.handleEBreceiptChange(data);
                            }}
                        />
                    </div>
                )}
            </div>

            <div onClick={() => this.addChild(value)}>
                <button
                    className="btn btn-sm btn-primary"
                    style={{ fontSize: "smaller" }}
                >
                    Add {title}
                </button>
            </div>
        </div>
    );
};
  checkOperation = (type, value, index) => {
    let isEditable = false;
    const { responseData } = this.state;
    if (responseData[type] && responseData[type].length < index + 1) {
      isEditable = true;
    }
    return isEditable;
  };

  render() {
    const { data, isOnlyView } = this.props;
    const { isOptionOpen, bgColor } = this.state;
    return (
      <div className="collapse-section count-doc-verify">
        <Accordion>
          <Card>
            <Accordion.Toggle
              style={{ background: data?.bgColor ? data?.bgColor : bgColor }}
              as={Card.Header}
              eventKey="8"
              onClick={() => {
                this.setState({ isOptionOpen: !isOptionOpen });
              }}
            >
              <h5>
                <b>EB Receipt</b>
              </h5>
              <i
                className={`icon feather icon-${
                  !isOptionOpen ? "plus" : "minus"
                }`}
                style={{
                  color: "black",
                  fontSize: "17px",
                  fontWeight: "bold",
                  float: "right",
                }}
              />
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="8">
              <Card.Body>
                <div>
                  {this.getAddButton("EB Receipt", "EBreceipt",true)}
                  {data?.EBreceipt &&
                    Array.isArray(data?.EBreceipt) &&
                    data?.EBreceipt.map((value, index) => {
                      return (
                        <>
                          <div className="row mb-10" key={index}>
                            <div className="col-md-4 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                Date Verified
                              </label>
                              {/* {data.file.btTransfer}/ */}
                              <div className="row" style={{ marginLeft: 0 }}>
                               <input
                                  className="form-control"
                                  name={
                                    "EBreceipt" +
                                    (value && value.dateVerified
                                      ? value.dateVerified
                                      : "") +
                                    index
                                  }
                                  type="text"
                                  value={
                                    value && value.dateVerified
                                      ? value.dateVerified
                                      : ""
                                  }
                                  onChange={(e) =>
                                    this.handleChildInputChange(
                                      "EBreceipt",
                                      "dateVerified",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                />                               
                              </div>
                            </div>
                            <div className="col-md-3 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                Property Owner Name Verified
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                  <input
                                  className="form-control"
                                  name={
                                    "EBreceipt" +
                                    (value && value.propertOwnerVerify
                                      ? value.propertOwnerVerify
                                      : "") +
                                    index
                                  }
                                  type="text"
                                  value={
                                    value && value.propertOwnerVerify
                                      ? value.propertOwnerVerify
                                      : ""
                                  }
                                  onChange={(e) =>
                                    this.handleChildInputChange(
                                      "EBreceipt",
                                      "propertOwnerVerify",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                />
                               
                              </div>
                            </div>
                            <div className="col-md-3 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                Amount Verified
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                   <input
                                  className="form-control"
                                  name={
                                    "EBreceipt" +
                                    (value && value.ebAmountverify
                                      ? value.ebAmountverify
                                      : "") +
                                    index
                                  }
                                  type="text"
                                  value={
                                    value && value.ebAmountverify
                                      ? value.ebAmountverify
                                      : ""
                                  }
                                  onChange={(e) =>
                                    this.handleChildInputChange(
                                      "EBreceipt",
                                      "ebAmountverify",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                />
                               
                              </div>
                            </div>
                            <div className="col-md-3 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                EB Receipt issued by Verified
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                                                   <input
                                  className="form-control"
                                  name={
                                    "EBreceipt" +
                                    (value && value.receiptIssuedByVerify
                                      ? value.receiptIssuedByVerify
                                      : "") +
                                    index
                                  }
                                  type="text"
                                  value={
                                    value && value.receiptIssuedByVerify
                                      ? value.receiptIssuedByVerify
                                      : ""
                                  }
                                  onChange={(e) =>
                                    this.handleChildInputChange(
                                      "EBreceipt",
                                      "receiptIssuedByVerify",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                />                                
                              </div>
                            </div>

                            {this.checkOperation("EBreceipt", value, index) && (
                              <div
                                className="form-group col-md-2"
                                style={{
                                  alignSelf: "center",
                                  fontSize: "initial",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  this.removeChild("EBreceipt", index)
                                }
                              >
                                <i
                                  style={{ color: "red" }}
                                  className="feather icon-minus-circle"
                                />
                              </div>
                            )}
                          </div>
                        </>
                      );
                    })}
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </div>
    );
  }
}

export default EBreceipt;
